import axios, { AxiosResponse } from "axios";

import { ADMINURL } from "./constants";
import {
  IIntroducerCommission,
  IIntroducerLogin,
  IIntroducerLoginOTP,
  IIntroducerMasterData,
  IIntroducerPayout,
} from "./dtos";
// import {

// } from "./dtos";

const axiosInterceptor = axios.create({
  baseURL: ADMINURL,
});

axiosInterceptor.interceptors.request.use(
  async (req) => {
    const token = sessionStorage.getItem("access-token");

    req.headers.Authorization = `Bearer ${token}`;
    return req;
  },
  (error) => Promise.reject(error)
);

axiosInterceptor.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response ? err.response.status : null;
    if (status === 401) {
      // console.log("Logout", status);
      handleLogout();
    }
    return Promise.reject(err);
  }
);
const handleLogout = () => {
  sessionStorage.clear();
  window.location.href = "/";
};

export const introducerLoginAPICall = (requestBody: IIntroducerLogin) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/introducer_login/`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const introducerResendOTPAPICall = (requestBody: IIntroducerLogin) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/resend_otp/`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const introducerLoginOTPValidationAPICall = (
  requestBody: IIntroducerLoginOTP
) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/otp_validation/`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const getClientDetailsAPICall = ({
  page_no,
  page_size,
  month,
  approval_status,
  filter_data,
}: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/get_client_details/`, {
        params: { page_no, page_size, month, approval_status, filter_data },
      })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: any) => {
        console.error(error);
        reject(error);
      });
  });
};
export const getApprovedClientDetailsAPICall = ({
  page_no,
  page_size,
  filter_data,
}: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/get_approved_clients/`, {
        params: { page_no, page_size, filter_data },
      })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: any) => {
        console.error(error);
        reject(error);
      });
  });
};
export const getClientCountAPICall = ({ month }: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/get_client_count/`, { params: { month } })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: any) => {
        console.error(error);
        reject(error);
      });
  });
};
export const getdashBoardRevenuedetailsAPICall = ({ month }: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/get_revenue_details/`, { params: { month } })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: any) => {
        console.error(error);
        reject(error);
      });
  });
};
export const getRevenueByClientAPICall = ({
  month,
  page_no,
  page_size,
}: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/get_revenue_by_client/`, { params: { month, page_no, page_size } })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: any) => {
        console.error(error);
        reject(error);
      });
  });
};
export const getRevenuedayWiseAPICall = ({
  month,
  day,
  page_no,
  page_size,
}: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/get_day_wise_revenue_details/`, {
        params: { month, day, page_no, page_size },
      })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: any) => {
        console.error(error);
        reject(error);
      });
  });
};
export const getdashBoardIntroducerCommissiondayWiseGraphDataAPICall = ({
  month,
}: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/get_day_wise_commission_graph_details/`, { params: { month } })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: any) => {
        console.error(error);
        reject(error);
      });
  });
};
export const getdashBoardRevenueGraphDataAPICall = ({ year }: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/get_payout_details/`, { params: { year } })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: any) => {
        console.error(error);
        reject(error);
      });
  });
};
export const getIntroducerDetailsAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/get_introducer_details/`)
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: any) => {
        console.error(error);
        reject(error);
      });
  });
};

//------------------------------Downloads-----------------------------------------------

export const DownloadRevenueDetailsAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/download_month_revenue_details/`, {
        params: { month: requestBody.month },
      })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const DownloadPayoutDetailsAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/download_payout_details/`, {
        params: { year: requestBody.year },
      })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const DownloadPendingClientsAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/download_pending_clients/`, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const DownloadApprovedClientsAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/download_approved_clients/`, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
